import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { MsgConfig } from "../app.messages";


@Injectable({
    providedIn: "root"
})
export class AlertService {
    public subject = new Subject<any>();
     keepAfterNavigationChange: boolean = false;
    public helpText = new Subject<any>();
    public userGuide = new Subject<any>();
    public inputFocus = "";
    constructor() {
        // clear alert message on route change
      /*  router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                if (this.keepAfterNavigationChange) {
                    // only keep for a single location change
                    this.keepAfterNavigationChange = false;
                } else {
                    // clear alert
                    this.subject.next();
                    this.helpText.next();
                }
            } 
            
            else if (event instanceof NavigationEnd) {
                if (googleApiKey && googleApiKey.length) {
                    gtag('config', environment.GoogleAnalyticsKey,
                        {
                            'page_path': event.urlAfterRedirects
                        }
                    );
                }
            } 
        });*/
    }

    success(
        message: string,
        keepAfterNavigationChange = false,
        timeInterval?: string
    ) {
        this.keepAfterNavigationChange = keepAfterNavigationChange;
        this.subject.next({
            type: "success",
            text: message,
            interval: timeInterval
        });
    }
    unsuccess(
        message: string,
        keepAfterNavigationChange = false,
        timeInterval?: string
    ) {
        this.keepAfterNavigationChange = keepAfterNavigationChange;
        this.subject.next({
            type: "unsuccess",
            text: message,
            interval: timeInterval
        });
    }

    error(
        message: string,
        keepAfterNavigationChange = false,
        timeInterval?: string,
        parentClass?: string
    ) {
        if(message.includes(MsgConfig.ENTER_REQ_FIELD)) {
            return; // Skipping showing error for Enter Required Field;
        }
        this.keepAfterNavigationChange = keepAfterNavigationChange;
        this.subject.next({
            type: "error",
            text: message,
            interval: timeInterval,
            parentClass: parentClass
        });
    }

    warning(
        message: string,
        keepAfterNavigationChange = false,
        timeInterval?: string,
        parentClass?: string
    ) {
        this.keepAfterNavigationChange = keepAfterNavigationChange;
        this.subject.next({
            type: "warning",
            text: message,
            interval: timeInterval,
            parentClass: parentClass
        });
    }

    update(
        message: string,
        keepAfterNavigationChange = false,
        timeInterval?: string
    ) {
        this.keepAfterNavigationChange = keepAfterNavigationChange;
        this.subject.next({
            type: "update",
            text: message,
            interval: timeInterval
        });
    }

    getMessage(): Observable<any> {
        return this.subject.asObservable();
    }

    showHelpText(message) {
        this.helpText.next(message);
    }

    getHelpText() {
        return this.helpText.asObservable();
    }

    showUserGuide(msg) {
        this.userGuide.next(msg);
    }

    getUserGuide() {
        return this.userGuide.asObservable();
    }
}
